import { useEffect } from "react";

const SITE_URL = "https://www.vinylux-covering.fr";
const DEFAULT_IMAGE = `${SITE_URL}/images/avatar.png`;

function upsertMeta(attribute, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
  schema = [],
}) {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path === "/" ? "/" : path}`;
    document.title = title;

    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex,follow" : "index,follow,max-image-preview:large");
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:locale", "fr_FR");
    upsertMeta("property", "og:site_name", "Vinylux");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonicalUrl);
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);

    document.querySelectorAll('script[data-vinylux-schema="true"]').forEach((node) => node.remove());
    const schemas = Array.isArray(schema) ? schema : [schema];
    schemas.filter(Boolean).forEach((item) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.vinyluxSchema = "true";
      script.textContent = JSON.stringify(item);
      document.head.appendChild(script);
    });
  }, [title, description, path, image, noindex, schema]);

  return null;
}

export const businessSchema = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: "Vinylux",
  url: SITE_URL,
  telephone: "+33695134999",
  image: DEFAULT_IMAGE,
  description: "Rénovation de cuisines par covering dans l'Ain, le Rhône et autour de Lyon.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Sainte-Olive",
    postalCode: "01330",
    addressCountry: "FR",
  },
  areaServed: [
    { "@type": "AdministrativeArea", name: "Ain" },
    { "@type": "City", name: "Lyon" },
    { "@type": "City", name: "Villefranche-sur-Saône" },
    { "@type": "City", name: "Bourg-en-Bresse" },
  ],
  sameAs: [
    "https://instagram.com/vinylux",
    "https://www.facebook.com/profile.php?id=61590669930852",
  ],
};
